import React from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Fade from "react-bootstrap/Fade";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {getAvatarUrl, getName} from "../../storage/user";

function StatisticsNode(props) {
    return (
        <>
            <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto">
                <h4 className="mb-0">{props.number}</h4>
                <p className="profile-muted-text">{props.description}</p>
            </Col>
        </>
    )
}

function FavoriteNode(props) {
    return (
        <>
            {props.value
                ? <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto">
                    <p className="skyduck-color mb-0">{props.title}</p>
                    <p>{props.value}</p>
                </Col>
                : null
            }
        </>
    )
}

export function Profile(props) {
    return (
        <Fade appear={true} in={true}>
            <div className="shadow rounded">
                <Card className="rounded-top bg-skyduck text-white">
                    <Card.Body className="card-bottom">
                        <Container>
                            <Row>
                                <Col xs="auto" sm="auto" md="auto" lg="auto" xl="auto">
                                    <img className="avatar" alt={getName()} src={getAvatarUrl()}/>
                                </Col>
                                <Col className="pl-0 align-self-center">
                                    <h5 className="mb-1">{getName()}</h5>
                                    <p className="mb-0 profile-muted-text">{props.state.statistics.lastJumpedText}</p>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <StatisticsNode number={props.state.statistics.totalJumpsCount} description="Jumps"/>
                                <StatisticsNode number={props.state.statistics.jumpsInCurrentYear} description={"Jumps in " + new Date().getFullYear()}/>
                                <StatisticsNode number={props.state.statistics.freefallTime} description="Freefall time"/>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>
                <Card className="rounded-bottom">
                    <Card.Body className="card-bottom">
                        <Container>
                            {props.state.statistics.favoriteDropzone
                                && props.state.statistics.favoriteAircraft
                                && props.state.statistics.favoriteCanopy
                                ? <Row>
                                    <FavoriteNode title="Favorite dropzone" value={props.state.statistics.favoriteDropzone}/>
                                    <FavoriteNode title="Favorite aircraft" value={props.state.statistics.favoriteAircraft}/>
                                    <FavoriteNode title="Favorite canopy" value={props.state.statistics.favoriteCanopy}/>
                                </Row>
                                : <Row>
                                    <p>Your favorite dropzone, aircraft and canopy would appear here.</p>
                                </Row>
                            }
                        </Container>
                    </Card.Body>
                </Card>
            </div>
        </Fade>
    )
}